import { Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LdwRouterService } from '../../../../route/ldw-router.service';
import { SettingsService } from '../../../../shared/settings/settings.service';
import { WebdokuService } from '../../../../web-doku/webdoku.service';
import { DocumentService } from '../../../../shared/services/document.service';
import { DocumentToolbarBaseComponent } from '../document-toolbar-base.component';

@Component({
    selector: 'ldw-document-toolbar-mobile',
    templateUrl: './document-toolbar-mobile.component.html',
    styleUrls: ['./document-toolbar-mobile.component.css'],
    standalone: false
})
export class DocumentToolbarMobileComponent extends DocumentToolbarBaseComponent {

  constructor() {
    const dialog = inject(MatDialog);
    const settingsService = inject(SettingsService);
    const webDokuService = inject(WebdokuService);
    const documentService = inject(DocumentService);
    const routerService = inject(LdwRouterService);

    super(dialog, settingsService, webDokuService, documentService, routerService);
  }
}
